export default __webpack_public_path__ + "static/media/memart-logo.b54f6185.svg";